import { Sites } from '@ps/platform-message-framework/common/Sites';
import { Translation } from '@ps/web-shared-components';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import useWizardExit from '@swf/core/hooks/useWizardExit';
import { select } from '@swf/core/store';
import AccountVerification from '@swf/verification/AccountVerification/AccountVerification';

import Container from '../../../Container/Container';
import HelpModal from '../../../HelpModal/HelpModal';
import useRmfLogout from '../../hooks/useRmfLogout';

import {
  TXTCLI_LetXs_get_you_verified,
  TXTWCL_We_need_to_verify_your_identit_ELL
} from './RMFVerification.messages.json';
import Celebration from './components/Celebration/Celebration';
import ProceedToDeposit from './components/ProceedToDeposit/ProceedToDeposit';
import Verification from './components/Verification/Verification';

const RMFVerification: React.FunctionComponent = () => {
  const exitWizard = useWizardExit();
  const site = useSelector(select.cms.getSiteId);
  const isFrance = site === Sites.FRA;
  const isUk = site === Sites.UK;
  const isCAON = site === Sites.CA_ON;
  const [panelVisible, setPanelVisible] = useState(false);
  const [showScreenToDeposit, setShowScreenToDeposit] = useState(false);

  const logout = useRmfLogout();

  const handleClose = () => {
    if (isUk || isCAON) {
      setPanelVisible(false);
    } else {
      exitWizard();
    }
  };

  const handleOnComplete = () => {
    if (isFrance) {
      setShowScreenToDeposit(true);
    } else {
      exitWizard();
      logout?.();
    }
  };

  return (
    <Container
      page={RMFVerification}
      headerProps={{
        title: <Translation {...TXTCLI_LetXs_get_you_verified} />,
        buttons: { back: !(isUk || isCAON) }
      }}
      pageTopTitle={<Translation {...TXTCLI_LetXs_get_you_verified} />}
      pageTopSubtitle={<Translation {...TXTWCL_We_need_to_verify_your_identit_ELL} />}
    >
      <Celebration />
      {isFrance && showScreenToDeposit && <ProceedToDeposit />}
      <Verification handleClick={() => setPanelVisible(true)} />
      <HelpModal
        visible={panelVisible}
        onClose={() => setPanelVisible(false)}
        title={TXTCLI_LetXs_get_you_verified}
      >
        <AccountVerification
          openIDScan
          showButton
          onComplete={handleOnComplete}
          onClose={handleClose}
          handleCancel={() => setPanelVisible(false)}
        />
      </HelpModal>
    </Container>
  );
};

RMFVerification.displayName = 'RMFVerification';

export default RMFVerification;
